import { SawTabletPage } from "../../pages/saw-tablet";

export const routeSawTablet = "/saw-tablet/20th-street-saw";

export const sawTabletRoutes = [
	{
		path: routeSawTablet,
		element: <SawTabletPage />,
	},
];
